import { useCallback, useContext } from 'react'

import { requestGetPairRates } from 'nexchange-service/module/coins'
import { ShowWarningAction, WarningContext } from 'nexchange-service/module/common'

import { useCoinInputLoadingSetter } from './useCoinInputLoadingSetter'
import { useOnGetPairErrorHandler, useOnGetPairSuccessHandler } from './handleResponse'
import { SelectedCoinsContext } from '../stateManagement'
import { ECoinInputType } from '../constants'

const useChangeAmountHandler = () => {
    const { dispatchAction: dispatchWarningAction } = useContext(WarningContext)

    const {
        state: { from, to },
    } = useContext(SelectedCoinsContext)

    const setCoinInputsLoading = useCoinInputLoadingSetter()
    const onGetPairSuccess = useOnGetPairSuccessHandler()
    const onGetPairError = useOnGetPairErrorHandler({ isClampToRangeEnabled: false })

    return useCallback(
        async ({
            amountValue,
            coinInputType,
            shouldHandleLoading = false,
        }: {
            amountValue: string
            coinInputType: ECoinInputType
            shouldHandleLoading?: boolean
        }) => {
            if (shouldHandleLoading) {
                setCoinInputsLoading(true)
            }

            try {
                const newAmount = Number(amountValue.replace(' ', '').replace(/,/g, '.'))

                const { data: apiPairDto, error } = await requestGetPairRates({
                    fromCode: from.code,
                    toCode: to.code,
                    amount: newAmount,
                    amountOf: coinInputType,
                })

                if (apiPairDto) {
                    onGetPairSuccess(apiPairDto)
                } else {
                    onGetPairError({
                        newAmount,
                        coinInputType,
                        errorDto: error,
                        dataLayerEvent: 'invalid_amount',
                    })
                }
            } catch (ex) {
                console.error(ex)
                dispatchWarningAction(
                    new ShowWarningAction(
                        'Something went wrong. Please try again or contact our support team.',
                    ),
                )
            }

            setCoinInputsLoading(false)
        },
        [from?.code, to?.code, onGetPairSuccess, onGetPairError],
    )
}

export { useChangeAmountHandler }
